/**
 * Options:
 * showCountryFlag - boolean
 */
appSocial.component('avatar', {
    templateUrl: 'shared/components/avatar/AvatarComponent.html',
    bindings: {
        trader: '<',
        options: '=avatarOptions'
    },
    controller: class AvatarComponent {
        constructor(SocialConstants) {
            this.countries = SocialConstants.countries;
            this.path = "https://social.pandats.com/avatars/production/";
            this.src = "";
        }

        $onInit() {
            this.setAvatar();
        }

        $onChanges(changes) {
            // console.log('[CHANGES]', changes);
            if (changes.trader) {
                this.setAvatar();
            }
        }

        setAvatar() {
            if (!_.isObject(this.trader)) {
                return;
            }

            if (!this.trader.avatar.length) {
                this.src = "img/social/" + this.trader.gender + this.trader.avatarHash + '.svg';
            } else {
                this.src = /^data/.test(this.trader.avatar)
                    ? this.trader.avatar
                    : this.path + this.trader.avatar;
            }

            if (this.options && this.options.showCountryFlag) {
                const country = this.countries
                    .find((_country) => _country.code.toLowerCase() === this.trader.country.toLowerCase());
                this.countryCode = !!country && country.code.toLowerCase();
                this.countryName = !!country && country.country;
            }
        }
    }
})
